import request from './index'

export function login(data) {
  return request({
    url: '/auth/login',
    method: 'post',
    data
  })
}

export function getSmsCode(mobile) {
  return request({
    url: '/auth/sms-code',
    method: 'post',
    data: { mobile }
  })
}

export function getMenuList() {
  return request({
    url: '/platform/menuList',
    method: 'get'
  })
}

export function getChargeList(query) {
  return request({
    url: '/platform/chargeList',
    method: 'get',
    params: query
  })
}

export function getDashborUserInfo(query) {
  return request({
    url: '/custom/user/info',
    method: 'get',
    params: query
  })
}

